<template>
  <div>
    <div class="flex items-center space-x-4">
      <h2>{{ isEditing ? "Editar" : "Crear" }} Administrador</h2>
    </div>

    <div v-if="!loading" class="card mt-2">
      <form @submit.prevent="save">
        <section-header title="Datos Personales" />

        <div class="form-grid">
          <div class="form-field">
            <label for="name">Nombre(s)</label>
            <input id="name" type="text" v-model="form.name" />
            <validation-errors :errors="errorFor('name')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="last_name">Apellido(s)</label>
            <input id="last_name" type="text" v-model="form.last_name" />
            <validation-errors
              :errors="errorFor('last_name')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="role">Rol</label>
            <custom-select
              id="role"
              v-model="form.role_id"
              :options="getRoleOptions()"
            />
            <validation-errors :errors="errorFor('role')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="email">Correo electrónico</label>
            <input id="email" type="email" v-model="form.email" />
            <validation-errors :errors="errorFor('email')"></validation-errors>
          </div>
        </div>

        <section-header title="Seguridad" />

        <div class="flex flex-col w-full">
          <div class="flex justify-between">
            <label for="password">Contraseña</label>
          </div>

          <input id="password" type="password" v-model="form.password" />

          <validation-errors :errors="errorFor('password')"></validation-errors>

          <password-validation
            class="mt-1"
            :password="form.password"
          ></password-validation>
        </div>

        <div class="flex flex-col w-full mt-4">
          <div class="flex justify-between">
            <label for="passwordConfirmation">Confirmar contraseña</label>
          </div>

          <input
            id="passwordConfirmation"
            type="password"
            v-model="form.password_confirmation"
          />

          <password-validation
            class="mt-1"
            :password="form.password"
            :passwordConfirmation="form.password_confirmation"
            :confirmation="true"
          ></password-validation>

          <validation-errors
            :errors="errorFor('password_confirmation')"
          ></validation-errors>
        </div>

        <primary-button type="submit" class="mt-6 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Guardar" : "Crear" }}
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import PasswordValidation from "@/components/ui/PasswordValidation";
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
export default {
  name: "Admin Form",

  components: {
    PasswordValidation,
  },

  data() {
    return {
      form: {
        name: "",
        last_name: "",
        role_id: null,
        email: "",
        password: "",
        password_confirmation: "",
      },
      loading: false,
      loadingForm: false,
      isEditing: false,
      roles: null,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "admins");

    this.loadRoles();

    if (this.$route.params.id) {
      this.isEditing = true;
      this.loadAdmin();
    }
  },

  mixins: [validationErrors],

  methods: {
    async loadRoles() {
      this.loading = true;

      try {
        this.roles = await api.roles.getAll();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    async loadAdmin() {
      this.loading = true;

      try {
        let admin = await api.admins.getById(this.$route.params.id);
        admin.email = admin.user.email;
        admin.role_id = admin.user.role_id;
        admin.password = "";
        admin.password_confirmation = "";

        delete admin.id;
        delete admin.user_id;
        delete admin.user;

        this.form = await JSON.parse(JSON.stringify(admin));
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    getRoleOptions() {
      const options = [{ value: null, label: "Seleccionar", disabled: false }];

      this.roles.forEach((role) => {
        options.push({
          value: role.id,
          label: role.name,
        });
      });

      return options;
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      if (!this.isEditing) {
        this.createAdmin();
      } else {
        this.updateAdmin();
      }
    },

    validateForm() {
      this.errors = {};

      if (!this.form.name) {
        this.errors["name"] = ["Campo requerido"];
      }

      if (!this.form.last_name) {
        this.errors["last_name"] = ["Campo requerido"];
      }

      if (!this.form.role_id) {
        this.errors["role"] = ["Campo requerido"];
      }

      if (!this.form.email) {
        this.errors["email"] = ["Campo requerido"];
      }

      if (
        !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          this.form.email
        )
      ) {
        this.errors["email"] = ["Correo electrónico inválido."];
      }

      if (this.isEditing) {
        if (
          this.form.password !== "" ||
          this.form.password_confirmation != ""
        ) {
          if (!this.form.password) {
            this.errors["password"] = ["Campo requerido"];
          }

          if (
            !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*.])(?=.{8,})/.test(
              this.form.password
            )
          ) {
            this.errors["password"] = ["Contraseña inválida."];
          }

          if (!this.form.password_confirmation) {
            this.errors["password_confirmation"] = ["Campo requerido"];
          }
        }
      } else {
        if (!this.form.password) {
          this.errors["password"] = ["Campo requerido"];
        }

        if (
          !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*.])(?=.{8,})/.test(
            this.form.password
          )
        ) {
          this.errors["password"] = ["Contraseña inválida."];
        }

        if (!this.form.password_confirmation) {
          this.errors["password_confirmation"] = ["Campo requerido"];
        }
      }

      if (this.form.password !== this.form.password_confirmation) {
        this.errors["password_confirmation"] = ["La contraseña no coincide."];
      }

      return Object.keys(this.errors).length === 0;
    },

    async createAdmin() {
      this.loadingForm = true;

      try {
        const response = await api.admins.create(this.form);
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: 'adminsIndex' });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },

    async updateAdmin() {
      this.loadingForm = true;

      try {
        const response = await api.admins.update(
          this.$route.params.id,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: 'adminsDetail', params: { id: this.$route.params.id } });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>